import { isLoggedIn } from "@common/hooks/use-auth"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod"
import LoginPage from "@/routes/-components"

// `redirect` holds the relative URL the user was sent here from, so login can
// return them to it (including any from_trace_id it carries).
const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute("/login")({
  component: LoginPage,
  validateSearch: searchSchema,
  beforeLoad: async () => {
    if (isLoggedIn()) {
      throw redirect({
        to: "/",
      })
    }
  },
})
